export const capitalize = <s extends string>(str: s) => (str.slice(0, 1).toUpperCase() + str.slice(1)) as Capitalize<s>
